import "./App.css";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import React, { useEffect } from "react";
import { AppBar, Button, Menu, MenuItem, Toolbar } from "@mui/material";
import Translation from "./pages/translation/Translation";
import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";
import Rotation from "./pages/rotation/Rotation";
import EulerAngles from "./pages/eulerangles/EulerAngles";
import Quaternion from "./pages/quaternion/Quaternion";
import HomogeneousTranslation from "./pages/homogeneousTransformations/HomogeneousTranslation";
import About from "./pages/about/About";
import DHModel from "./pages/DHModel/DHModel";
import ModifiedDHModel from "./pages/ModifiedDHModel/ModifiedDHModel";
import { createTheme } from "@mui/material/styles";
import More from "./pages/More/More";
import Jacobian2DIK from "./pages/2D Jacobian IK/2DJacobianIK";
import Lagrange from "./pages/Lagrange/Lagrange";
import NumericalMethodsforODE from "./pages/NumericalMethodsforODE/NumericalMethodsforODE";
import IK from "./pages/IK/IK";
import PID from "./pages/PID/PID";
import MegaMenu from "./utils/MegaMenu";
import Voronoi from "./pages/Voronio/Voronio";
import GeneralizedVoronoi from "./pages/GeneralizedVoronio/GeneralizedVoronio";
import PathPlanningVoronoi from "./pages/PathPlanningVoronio/PathPlanningVoronio";
import Others from "./pages/Others/Others";
import Dijkstras from "./pages/Dijkstras/Dijkstras";
import DijkstrasForGrids from "./pages/DijkstrasForGrids/DijkstrasForGrids";
import AstarForGrids from "./pages/AstarForGrids/AstarForGrids";
import CellDecomposition from "./pages/CellDecomposition/CellDecomposition";

const theme = createTheme({
  palette: {
    primary: {
      light: "#757ce8",
      main: "#3f50b5",
      dark: "#002884",
      contrastText: "#fff",
    },
    secondary: {
      light: "#ff7961",
      main: "#f44336",
      dark: "#ba000d",
      contrastText: "#000",
    },
  },
});

const navItems = [{ name: "About", route: "/about" }];

function App() {
  const location = useLocation();
  const { hash, pathname, search } = location;
  const [value, setValue] = React.useState("/translation");

  useEffect(() => {
    setValue(pathname);
  }, [pathname]);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="App">
      <AppBar
        sx={{ minHeight: 40, height: 48 }}
        position="static"
        color="transparent"
        elevation={0}
      >
        <Toolbar>
          <Link to={`/`}>
            <img
              src="/logo512.png"
              alt="logo"
              style={{ maxWidth: 32, marginRight: 20 }}
            />
          </Link>
          <Typography
            variant="h6"
            component="div"
            sx={{
              textAlign: "left",
              flexGrow: 1,
              display: { xs: "none", sm: "block" },
              fontSize: 18,
            }}
          >
            Robotics101 from VisCircuit
          </Typography>
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <Button
              sx={{ fontSize: 13 }}
              key={"VisCircuit"}
              component={Link}
              to={"https://viscircuit.com"}
            >
              {"VisCircuit"}
            </Button>
            <Button sx={{ fontSize: 13 }} onClick={handleMenu}>
              Community
            </Button>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem component={Link} to="https://discord.gg/TfwZ3hH2D2">
                Discord
              </MenuItem>
            </Menu>
            {navItems.map((item) => (
              <Button
                sx={{ fontSize: 13 }}
                key={item.name}
                component={Link}
                to={item.route}
              >
                {item.name}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </AppBar>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
        }}
      >
        <MegaMenu />

        <Routes>
          <Route index element={<Navigate to="/robotics/translation" />} />
          <Route path="/about" element={<About />} />

          <Route
            path="/translation"
            element={<Navigate to="/robotics/translation" />}
          />
          <Route
            path="/rotation"
            element={<Navigate to="/robotics/rotation" />}
          />
          <Route
            path="/eulerangles"
            element={<Navigate to="/robotics/eulerangles" />}
          />
          <Route
            path="/quaternion"
            element={<Navigate to="/robotics/quaternion" />}
          />
          <Route
            path="/homogeneous-transformations"
            element={<Navigate to="/robotics/homogeneous-transformations" />}
          />
          <Route
            path="/dh-model"
            element={<Navigate to="/robotics/dh-model" />}
          />
          <Route
            path="/modified-dh-model"
            element={<Navigate to="/robotics/modified-dh-model" />}
          />
          <Route path="/ik" element={<Navigate to="/robotics/ik" />} />
          <Route
            path="/2d-jacobian-ik"
            element={<Navigate to="/robotics/2d-jacobian-ik" />}
          />
          <Route
            path="/lagrange"
            element={<Navigate to="/robotics/lagrange" />}
          />
          <Route path="/pid" element={<Navigate to="/robotics/pid" />} />
          <Route path="/robotics">
            <Route path="translation" element={<Translation />} />
            <Route path="rotation" element={<Rotation />} />
            <Route path="eulerangles" element={<EulerAngles />} />
            <Route path="quaternion" element={<Quaternion />} />
            <Route
              path="homogeneous-transformations"
              element={<HomogeneousTranslation />}
            />
            <Route path="dh-model" element={<DHModel />} />
            <Route path="modified-dh-model" element={<ModifiedDHModel />} />
            <Route path="ik" element={<IK />} />
            <Route path="2d-jacobian-ik" element={<Jacobian2DIK />} />
            <Route path="lagrange" element={<Lagrange />} />
            <Route path="pid" element={<PID />} />
            <Route path="voronoi" element={<Voronoi />} />
            <Route
              path="generalized-voronoi-diagram"
              element={<GeneralizedVoronoi />}
            />
            <Route
              path="path-planning-with-voronoi"
              element={<PathPlanningVoronoi />}
            />
            <Route path="dijkstras" element={<Dijkstras />} />
            <Route path="dijkstras-for-grids" element={<DijkstrasForGrids />} />
            <Route path="astar-for-grids" element={<AstarForGrids />} />
            <Route path="cell-decomposition" element={<CellDecomposition />} />
            <Route
              path="numerical-methods-for-ode"
              element={<NumericalMethodsforODE />}
            />
            <Route path="more" element={<More />} />
          </Route>
          <Route path="/*" element={<Others />} />
        </Routes>
      </Box>
    </div>
  );
}

export default App;
